'use client';

import { QueryKeys } from '@/constants/query-keys';
import { FeatureFlags } from '@/types/feature-flags';
import { useQuery } from '@tanstack/react-query';

export const useFeatureFlags = (): ReturnType<typeof useQuery<FeatureFlags>> => {
  return useQuery({
    queryFn: (): Promise<FeatureFlags> => {
      // this should never actually run since we'll always have cached data
      // but we need a queryFn for TypeScript
      throw new Error('Feature flag issue has occurred');
    },
    queryKey: QueryKeys.global.featureFlags,
    retry: false, // don't retry since we pre-cache
    // we don't expect feature flags to change during a session, so we only fetch on page reload, we will "never" query again
    staleTime: Infinity,
  });
};
